module.exports = __webpack_public_path__ + "files/c644f55c6e5b969bbb463b36020f761c.png";